import { render } from "./Testimonial.vue?vue&type=template&id=be924506&scoped=true"
import script from "./Testimonial.vue?vue&type=script&lang=js"
export * from "./Testimonial.vue?vue&type=script&lang=js"

import "./Testimonial.vue?vue&type=style&index=0&id=be924506&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-be924506"

export default script